const currencyDialog = {
  props: {
    dynamicClass: ".c-currency-dialog.dynamicLoading",
    idDescriptionText: "currency-dialog-desc",
    targetPlaceholder: "[targetcurrency]",
    currentPlaceholder: "[currentcurrency]",
    symbolPlaceholder: "[currencysymbol]",
    idTargetCurrency: "target-currency",
    idCurrentCurrency: "current-currency",
    localStorageCurrency: "barcelo_currency",
    localStorageLanguage: "barcelo_language",
    classCurrencyDialog: "currency-dialog-container-JS",
    classBtn: "c-cta",
    classNameClose: "ribbon-close-btn-JS",
    locale: "data-locale",
    localStorageName: "currencyDialog",
    localStorageSelection: "selection_currency",
    OnlyCurrency: "OC",
    CurrencyAndShop: "CS",
    notChangeShop: true,
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-currencyDialog.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document;
    const $component = baseFind.getElementsByClassName(this.props.classCurrencyDialog);
    if (!$component || !$component[0]) {
      return;
    }

    const promise = new Promise((resolve) => {
      const countdown = setInterval(() => {
        if (bcl.contextHub) {
          const targetCountry = bcl.contextHub.getItem("profile", "country_code") || "ES";
          if (targetCountry) {
            clearInterval(countdown);
            resolve(targetCountry);
          }
        }
      }, 1000);
    });

    promise
      .then((targetCountry) => {
        this.initCurrencyDialog($component[0], targetCountry);
        this.initNodes(baseFind);
      })
      .catch(function (reason) {
        console.error("Error en promesa (" + reason + ")");
      });
  },

  checkCurrentCurrency: function () {
    return this.props.currencyCode == this.props.currentCurrencyCode;
  },

  checkCurrentShop: function (targetCountry) {
    const $currentCountry = document.querySelector("[data-current-country-shop-selector=true]");
    if ($currentCountry) {
      const currentCountry = $currentCountry.getAttribute("data-country-shop-selector");
      this.props.notChangeShop = currentCountry && currentCountry.toLowerCase() == targetCountry.toLowerCase();
      return this.props.notChangeShop;
    }
    return this.props.notChangeShop;
  },

  checkLocalStorage: function () {
    return (localStorage.getItem(this.props.localStorageCurrency) && localStorage.getItem(this.props.localStorageLanguage)) || localStorage.getItem(this.props.localStorageSelection);
  },

  initCurrencyDialog: function (container, targetCountry) {
    if (targetCountry) {
      this.getPropertiesCurrency(targetCountry);
      if (!this.checkLocalStorage() && (!this.checkCurrentShop(targetCountry) || !this.checkCurrentCurrency()) && this.props.nodeCurrencyCountry) {
        this.changeTextForVersion();
        const buttonTarget = document.getElementById(this.props.idTargetCurrency);
        this.removeHref(buttonTarget);
        if (!this.props.notChangeShop) {
          this.modifyHref(buttonTarget, targetCountry);
        }
        buttonTarget.addEventListener("click", (e) => {
          this.clickChangeCurrency(this.props.nodeCurrencyCountry);
          localStorage.setItem(this.getNameAttr(this.props.localStorageSelection), true);
          if (e.target.href) {
            bcl.u.addBhgLoading();
            window.location.href = e.target.href;
          }
        });
        const buttonCurrent = document.getElementById(this.props.idCurrentCurrency);
        this.removeHref(buttonCurrent);
        buttonCurrent.addEventListener("click", (e) => {
          localStorage.setItem(this.getNameAttr(this.props.localStorageSelection), true);
          this.clickClose(e);
        });
        if (container && container.closest(".ribbon-currency-JS")) {
          this.nodeInParsys(container.closest(".ribbon-currency-JS").parentNode);
        }
      }
    }
  },

  changeTextForVersion: function () {
    if (!this.props.notChangeShop) {
      this.changeAllText(this.props.CurrencyAndShop);
    } else {
      this.changeAllText(this.props.OnlyCurrency);
    }
  },

  changeAllText: function (version) {
    this.changeText("description" + version, this.props.idDescriptionText, this.props.nodeCurrencyCountry.dataset.title, this.props.targetPlaceholder);
    this.changeText("description" + version, this.props.idDescriptionText, this.props.nodeCurrentCurrency.dataset.title, this.props.currentPlaceholder);
    this.changeText("description" + version, this.props.idDescriptionText, this.props.currencySymbol, this.props.symbolPlaceholder);
    this.changeTextButton("buttonYes" + version, this.props.idTargetCurrency, this.props.nodeCurrencyCountry.dataset.title + "(" + this.props.nodeCurrencyCountry.dataset.symbol + ")", this.props.targetPlaceholder);
    this.changeTextButton("buttonNo" + version, this.props.idCurrentCurrency, this.props.nodeCurrentCurrency.dataset.title + "(" + this.props.nodeCurrentCurrency.dataset.symbol + ")", this.props.currentPlaceholder);
  },

  nodeInParsys: function ($containerCurrencyDialog) {
    const $divInsideMainContainer = document.querySelector("main.root > div > div.iparsys"),
      $currencyDialogElement = bcl.c.header.language.insertAsideToDiv($containerCurrencyDialog);
    if ($currencyDialogElement && $divInsideMainContainer) {
      $divInsideMainContainer.appendChild($currencyDialogElement);
    }
  },

  insertAsideToDiv: function ($element) {
    let ribbonDivExisted = document.querySelector("main.root > div > div.iparsys .currency-dialog.ribbon");
    if (ribbonDivExisted) {
      return;
    }
    bcl.u.addClass($element, "ribbon section");
    ribbonDivExisted = $element;
    return ribbonDivExisted;
  },

  initNodes: function (baseFind) {
    bcl.u.forEach(baseFind.getElementsByClassName("currency-dialog"), ($element) => {
      if (bcl.u.containsClass($element, bcl.c.ribbon.props?.classNameShow)) {
        return;
      }

      this.searchNodesForClose($element, this.clickClose);

      if (bcl.editMode || (bcl.c.ribbon.isValid($element) && !localStorage.getItem(this.getNameAttr()))) {
        bcl.u.addClass($element, bcl.c.ribbon.props?.classNameShow);
      }
    });

    bcl.u.forEach(baseFind.querySelectorAll("main.root > div .parsys .currency-dialog.ribbon"), ($element) => {
      this.searchNodesForClose($element, bcl.c.ribbon.clickCloseDeleteMarginHeader);

      const index = bcl.s.sticky.add(
        {
          $node: $element,
          callbackValid: bcl.c.ribbon.isValid.bind(bcl.c.ribbon),
          inHeader: true,
        },
        true,
      );

      $element.setAttribute(bcl.c.ribbon.props.nameAttrIndex, index);
    });
  },

  clickClose: function (e) {
    const $ribbon = e.target.classList.contains("currency-dialog") ? e.target : e.target.closest(".currency-dialog");

    if ($ribbon) {
      bcl.u.removeClass($ribbon, bcl.c.ribbon.props?.classNameShow);
    }
  },

  searchNodesForClose: function ($element, callback) {
    const $closeBtns = $element.getElementsByClassName(this.props.classNameClose);

    bcl.u.forEach($closeBtns, ($closeBtn) => {
      $closeBtn.addEventListener("click", callback);
    });
  },

  getNameAttr: function () {
    return "barcelo_" + this.props.localStorageName;
  },

  modifyHref: function (button, targetCountry) {
    const anchor = button.getElementsByClassName(this.props.classBtn);
    if (anchor && anchor[0]) {
      const hpcode = this.getHpCode(targetCountry);
      if (hpcode) {
        const targetUrl = this.getTargetUrl(hpcode);
        if (targetUrl) {
          anchor[0].setAttribute("href", targetUrl);
        }
      }
    }
  },

  getTargetUrl: function (hpcode) {
    const $targetLanguage = document.querySelector("link[hreflang=" + hpcode.toLowerCase() + "]");
    if ($targetLanguage) {
      return $targetLanguage.getAttribute("href") + window.location.search;
    }
  },

  getHpCode: function (targetCountry) {
    if (targetCountry && bcl.c.header.language) {
      const $associateSelect = document.querySelector(".marketLanguageList-JS");
      if ($associateSelect) {
        const currentLanguage = document.getElementsByClassName(this.props.classCurrencyDialog)[0].getAttribute(this.props.locale);
        let $targetLanguage = currentLanguage ? $associateSelect.querySelector("[data-country-shop-selector=" + currentLanguage.toLowerCase() + "]") : "";
        if (!$targetLanguage) {
          $targetLanguage = $associateSelect.querySelector("[data-country-shop-selector=" + targetCountry.toLowerCase() + "]");
        }
        if (!$targetLanguage) {
          $targetLanguage = $associateSelect.children[0];
        }
        return $targetLanguage?.dataset.hpCode;
      }
    }
  },

  removeHref: function (button) {
    const anchor = button.getElementsByClassName(this.props.classBtn);
    if (anchor && anchor[0]) {
      anchor[0].removeAttribute("href");
    }
  },

  getPropertiesCurrency: function (targetCountry) {
    const nodeCurrency = document.querySelector(".currencyCountryList-JS[data-countryCurrency=" + targetCountry + "]");
    if (nodeCurrency && nodeCurrency.dataset) {
      this.props.currencyCode = nodeCurrency.dataset.currencycountrycode;
      this.props.currencySymbol = nodeCurrency.dataset.symbol;
      this.props.nodeCurrencyCountry = nodeCurrency;
      const currencyRateNode = document.querySelector(".currencyList-JS[data-value=" + this.props.currencyCode + "]");
      this.props.currencyRate = currencyRateNode?.dataset.rate;
    }
    this.props.currentCurrencyCode = localStorage.getItem("barcelo_currency") || document.body.dataset.currency;
    this.props.nodeCurrentCurrency = document.querySelector(".currencyList-JS[data-value=" + this.props.currentCurrencyCode + "]");
  },

  changeText: function (idNameVersion, idName, replace, placeholder) {
    const descriptionTextVersion = document.getElementById(idNameVersion);
    let text = descriptionTextVersion.innerHTML;
    text = text.replace(placeholder, replace);
    const nodeDescription = document.getElementById(idName);
    nodeDescription.innerHTML = text;
    descriptionTextVersion.innerHTML = text;
  },

  changeTextButton: function (idNameVersion, idName, replace, placeholder) {
    const textVersion = document.getElementById(idNameVersion);
    let text = textVersion.innerHTML;
    text = text.replace(placeholder, replace);
    const nodeButton = document.getElementById(idName);
    const anchorNode = nodeButton.querySelector("a");
    if (anchorNode) {
      anchorNode.innerText = text;
      anchorNode.title = text;
      anchorNode.attributes["aria-label"].value = text;
    } else {
      textVersion.innerHTML = text;
      nodeButton.appendChild(textVersion);
    }
  },

  clickChangeCurrency: function (currencyNode) {
    bcl.u.addBhgLoading();
    if (bcl.s.currency) {
      bcl.s.currency.changeCurrency(currencyNode.dataset.currencycountrycode, this.props.currencyRate, currencyNode.dataset.title);
    }
    bcl.u.removeBhgLoading();
  },
};

export default currencyDialog;
